export default __webpack_public_path__ + "static/media/userimg2.9a9c95e2.png";